export const getVariations = (state) => state.variations;
